// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trf-sticky-table-header th, .trf-sticky-table-header td {\n  vertical-align: middle;\n}\n#hiddenCheckbox {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
